/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './startPhoneVerification.defs'
export { main as default } from './startPhoneVerification.defs'
